import { PriceDiscount } from "features/vehicleDetails/components/VehicleOverview/components/PriceFinanceSummary";
import { ResponseVehicle } from "services/motorpoint/shortlist";
import { VehicleService } from "services/vehicle/vehicle";

import getCurrentSellingPrice from "./getCurrentSellingPrice";

const getPreviousPriceAndDiscount = (
    vehicle: VehicleService.Vehicle | ResponseVehicle,
    savingThreshold: number
): PriceDiscount | undefined => {
    const vehicleFull = vehicle as VehicleService.Vehicle;
    const vehicleResponse = vehicle as ResponseVehicle;

    if (!vehicleFull.ShowDiscount || !vehicleResponse.ShowDiscount) return undefined;

    const currentSellingPrice = getCurrentSellingPrice(vehicle);

    if (!vehicleFull.PreviousPrices?.length && !vehicleResponse.Discount) return undefined;

    const mostRecentPricingHistory = getMostRecentPricingHistory(vehicle, currentSellingPrice);

    if (!mostRecentPricingHistory?.Price || mostRecentPricingHistory.Price <= currentSellingPrice)
        return undefined;

    const discount = mostRecentPricingHistory.Price - currentSellingPrice;

    if (discount < savingThreshold) return undefined;

    return {
        moneyOff: discount,
        previousPrice: mostRecentPricingHistory?.Price,
    };
};

const getMostRecentPricingHistory = (
    vehicle: VehicleService.Vehicle | ResponseVehicle,
    currentSellingPrice: number
): VehicleService.PreviousPrice | undefined => {
    const vehicleFull = vehicle as VehicleService.Vehicle;
    const vehicleResponse = vehicle as ResponseVehicle;

    if (!!vehicleFull.PreviousPrices?.length) {
        const sorted = vehicleFull.PreviousPrices.sort((a, b) => {
            const aTime = new Date(a.AppliedUntil).getTime();
            const bTime = new Date(b.AppliedUntil).getTime();
            return bTime - aTime;
        }).filter((price) => price.Price !== currentSellingPrice);

        return sorted?.[0] ?? undefined;
    }

    if (!!vehicleResponse.Discount && !!vehicleResponse.CurrentPrice) {
        const previousPrice: VehicleService.PreviousPrice = {
            AppliedUntil: new Date().toISOString(),
            Price: vehicleResponse.CurrentPrice - vehicleResponse.Discount,
        };

        return previousPrice;
    }

    return undefined;
};

export default getPreviousPriceAndDiscount;
